import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

function LoadingView({ loading, children, error }) {
  if (loading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <LoadingOutlined style={{ fontSize: "50px" }} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex justify-center items-center">
        <p className="text-red-600 text-[14px] text-center">{error}</p>
      </div>
    );
  }

  return <div className="h-screen">{children}</div>;
}

export default LoadingView;
